import {sha256} from "js-sha256";

export function setupQuoraPixel(event, name, data) {
  ;(function (q, d) {
    if (!q.qp) {
      const n = q.qp = function () {
        n.qp ? n.qp.apply(n, arguments) : n.queue.push(arguments)
      }
      n.queue = []

      const t = d.createElement('script')
      t.async = true
      t.src = 'https://a.quora.com/qevents.js'

      const s = d.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(t, s)

      let email = window.localStorage.getItem('email')

      if (email)
        email = email.replace(/(\+.*)?@/, '@').replace(/^(.+)@/, (_, user) => {
          return user.split(' ')[0] + '@'
        }) + email.split('@')[1]

      q.qp('init', '82e11aa0cd8247d5ae8f24c72dc20d8c', {
        // Email will be hashed by the pixel using SHA-256
        email: email || undefined
      })
    }
  })(window, document)

  if (event)
    window.qp(event, name, {
      click_id: window.localStorage.getItem('qclid'),
      event_id: sha256(`${name}_${window.session_uid}`),
      ...data
    })
}